<template>

    <div>
        <a-modal
            :title="menuItem.pageTitle"
            :visible="visible"
            :confirm-loading="confirmLoading"
            width="650px"
            @cancel="handleCancel"
        >
            <a-form-model
                :model="menuItem"
                ref="ruleForm"
                :rules="rules"
                :layout="formItemLayout"
                :label-col="labelCol"
                :wrapper-col="wrapperCol"
            >
                <a-form-model-item ref="name" label="菜单名" prop="name">
                    <a-input
                        v-model="menuItem.name"
                        aria-placeholder="请输入权限/菜单名"
                        @blur="
                        () => {
                            $refs.name.onFieldBlur();
                        }
                        "
                    />
                </a-form-model-item>
                <a-form-model-item label="菜单类型">
                    <a-select v-model="menuItem.hookconfig"  prop="hookconfig" :disabled="hookDisabled">
                        <a-select-option value="0" v-if="menuItem.level == '1' || menuItem.level == '2'">文档菜单</a-select-option>
                        <a-select-option value="3" v-if="menuItem.level == '1' || menuItem.level == '2'">API菜单</a-select-option>

                        <a-select-option value="1" v-if="menuItem.level == '3'">列表</a-select-option>
                        <a-select-option value="2" v-if="menuItem.level == '3' ">单文档</a-select-option>
                        <a-select-option value="4" v-if="menuItem.level == '3' ">普通菜单</a-select-option>
                    </a-select>

                    <a-popover placement="topLeft" arrow-point-at-center>
                        <template slot="content">
                            <p>菜单：导航菜单</p>
                            <p>文档列表：显示文档列表</p>
                            <p>单文档：显示单个文档</p>
                        </template>
                        <span slot="title">说明：</span>
                        <a-icon type="question-circle" class="question1" />
                    </a-popover>
                </a-form-model-item>

                <a-form-model-item ref="url" label="路径" prop="url" v-if="menuItem.hookconfig == '4'">
                    <a-input
                        v-model="menuItem.url"
                        aria-placeholder="请输入菜单路径"
                        @blur="
                        () => {
                            $refs.url.onFieldBlur();
                        }
                        "
                    />
                </a-form-model-item>
     
                <a-form-model-item ref="menucode" label="菜单编码" prop="menucode">
                    <a-input-search
                        v-model="menuItem.menucode"
                        enter-button="生成编码"
                        readonly="readonly"
                        :disabled="menuItem.menucode != ''"
                        @search="generateMenuCode"
                        @blur="() => { $refs.menucode.onFieldBlur();}"
                    />
                </a-form-model-item>
               

                

                <a-form-model-item label="状态">
                    <a-select v-model="menuItem.status"  prop="status">
                        <a-select-option value="0">禁用</a-select-option>
                        <a-select-option value="1">使用</a-select-option>
                    </a-select>
                </a-form-model-item>

                <a-form-model-item ref="ordernum" label="排序" prop="ordernum">
                    <a-input
                        v-model="menuItem.ordernum"
                        aria-placeholder="请输入排序号"
                    />
                </a-form-model-item>
            </a-form-model>
            <template slot="footer">
                <a-button key="back" @click="handleCancel">
                    取消
                </a-button>
                <a-button key="submit" type="primary" :loading="confirmLoading" @click="handleOk">
                    保存
                </a-button>
            </template>


        </a-modal>
    </div>

</template>
<script>


export default {

    data() {
        return {
            menuModalStatus: {
                isShow: false,
            },
            actionModalStatus: {
                isShow: false,
            },
            labelCol: {span: 6},
            wrapperCol: {span: 14},
            rules: {
                name: [
                    {required: true, message: '请填写菜单名', trigger: 'blur'},
                ],
                url: [
                    {required: true, message: '请填写URL', trigger: 'blur'},
                ],
                menucode: [
                    {required: true, message: '请生产菜单编码', trigger: 'blur'},
                ],
                
            },
            confirmLoading: false,
            formItemLayout: 'inline',
            visible: false,
            menuItem: {
                status:undefined,
                menucode:'',
                id: undefined,
                pid: undefined,
                name: '',
                subname: '',
                type: 1,
                url: '',
                actionpath: '',
                remark: '',
                ordernum: '',
                icon: '',
                hookconfig: undefined,
                platfromcode: '',
                level: '',
            },
            allMenucodes:[],
            hookDisabled:false,
        };
    },
    computed: {},
    components: {
    },
    props: {},
    methods: {
        onModalInit(item,allMenucodes,hookDisabled) {
            this.hookDisabled = hookDisabled
            this.visible = true;
            this.allMenucodes = allMenucodes
            this.menuItem =  {
                pageTitle:item.title,
                id: item.id,
                pid: item.pid,
                name: item.name,
                subname: '',
                type: 1,
                url: item.url,
                menucode: item.menucode,
                actionpath: '',
                status: '1',
                remark: '',
                ordernum: item.ordernum,
                icon: '',
                hookconfig: item.hookconfig,
                platfromcode: item.platfromcode,
                pmenucode:item.pmenucode,
                level: item.level,
                createtime: item.createtime,
                updatetime: item.updatetime,
            }
            
        },

        formatZero(num, len) {
            if (String(num).length > len) return num;
            return (Array(len).join(0) + num).slice(-len);
        },
        generateNum(num) {
            let s = [];
            let hexDigits = '0123456789abcdef';
            for (let i = 0; i < num; i++) {
                s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
            }
            return s.join('');
        },
        generateMenuCode() {
            /**
             * 菜单编码格式
             * 1.菜单  pid后两位 level 
             */
            let tempMenuCode = this.menuItem.level + '' + this.G.RndNum(5);
            if(this.allMenucodes.indexOf(tempMenuCode) != -1){
                this.generateMenuCode();
            }
            else{
                this.menuItem.menucode = this.menuItem.level + '' + this.G.RndNum(5);
            }
        },
        handleOk() {
            let that = this
            that.$refs.ruleForm.validate(valid => {
                if (valid) {
                    that.menuItem.icon = that.hookconfig == '0' ? "file-word" : "ordered-list";
                    that.confirmLoading = true;
                    if (that.menuItem.id) {
                        //编辑
                        this.$store
                            .dispatch({
                                type: "ums/updateMenuConfig",
                                params: this.menuItem
                            })
                            .then((response) => {
                                if (response.data.success == '1') {
                                    that.visible = false;
                                    that.$emit('onModalHide',that.menuItem);
                                    that.confirmLoading = false;
                                    that.message.success('保存成功')
                                }
                            });
                    } else {
                        //新增
                        that.$store
                            .dispatch({
                                type: "ums/insertMenuConfig",
                                params: this.menuItem
                            })
                            .then((response) => {
                                if (response.data.success == '1') {
                                    that.visible = false;
                                    that.$emit('onModalHide',that.menuItem);
                                    that.message.success('保存成功')
                                }
                                that.confirmLoading = false;

                            });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },

        handleCancel(e) {
            e.preventDefault()
            this.resetForm();
            this.visible = false;
            this.$emit('onModalHide');
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },
    },
};
</script>

<style scoped>
.ant-form-inline .ant-form-item {
    width: 100%;
}
.question1{
    font-size: 22px;
    position: absolute;
    right: -34px;
    top: -2px;
}
</style>
